import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadLinksCriteria {
    dashboardId: string;
    locationId: string;
}

class ReadLinksCriteriaImpl implements ReadLinksCriteria {
    constructor(readonly dashboardId: string, readonly locationId: string) {}
}

export class ReadLinksCriteriaBuilder {
    private dashboardId: Option<string> = none;

    private locationId = '';

    static create = (): ReadLinksCriteriaBuilder => new ReadLinksCriteriaBuilder();

    withDashboardId = (dashboardId: string): ReadLinksCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    withLocationId = (locationId: string): ReadLinksCriteriaBuilder => {
        this.locationId = locationId;
        return this;
    };

    build = (): ReadLinksCriteria => {
        if (isNone(this.dashboardId) || this.locationId === '') {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadLinksCriteriaImpl(this.dashboardId.value, this.locationId);
    };
}
